import { render, staticRenderFns } from "./event-registrations.vue?vue&type=template&id=fbd16ac6"
import script from "./event-registrations.vue?vue&type=script&lang=ts"
export * from "./event-registrations.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports